<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div
            class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">

            <div
                class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-2 py-2 sm:p-1 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Add Measurement</h6>
                </div>
                
                <label>Date : <input type="date" v-model="sale.date"></label>
            </div>

              <div  class = "mt-2" >
                <lable>Invoice Number</lable>
                      <input 
                                         
                                            type="number" 
                                            class="form-input" 
                                            v-model="invoice.invoice_no" 
                                            style="width: 10%;"
                                           
                                        />
                </div>

            <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                <table class="table-auto w-full ">
                    <tbody>
                        <tr>
                            <td class="dark:text-white">Customer Name </td>
                            <td class="dark:text-white">Cell</td>
                            <td class="dark:text-white">Dob</td>
                            <td class="dark:text-white">Address</td>
                            <td class="dark:text-white">Balance</td>
                        </tr>
                        <tr>
                            <td class="prd_name_col"> <select class="form-input" id="cust_name" ref="cust_name"
                                    v-model="sale.custid" autofocus>
                                    <option v-for="(item ,index)  in customerList" :value="item.id">{{item.name+' '+item.cell}}</option>
                                </select></td>
                            <td class="prd_val_col">{{ sale.custcell }}</td>
                            <td class="prd_val_col">{{ sale.dob }}</td>
                            <td class="prd_val_col">{{ sale.custaddress }}</td>
                            <td :class="sale.balance>0 ? 'prd_val_col text-danger':'prd_val_col text-info'">{{sale.balance?parseInt(sale.balance):0 }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>

<button class="btn b-solid btn-success-solid cursor-pointer shadow-sm shirt_btn" ref="shirt_btn" @click="openMeasurementModal(1)">Shirt</button>
   <button class="btn b-solid btn-danger-solid cursor-pointer shadow-sm pant_btn" ref="pant_btn" @click="openMeasurementModal(2)">Pant</button>



   <!-- table -->
   
<div class="col-span-full">
    <div class="card p-0">
        <div class="p-6 space-y-4 overflow-x-auto">
            
            <table class="table-auto w-full border border-gray-300">
                
                <thead>
                    <tr class="bg-gray-200">
                        <th class="border border-gray-300 px-2 py-1">#</th>
                        <th class="border border-gray-300 px-2 py-1">Stitching</th>
                          <th class="border border-gray-300 px-2 py-1">Qty</th>
                         <th class="border border-gray-300 px-2 py-1">Measurements</th>
                         <th class="border border-gray-300 px-2 py-1">Delivery</th>
                          <th class="border border-gray-300 px-2 py-1">Action</th>
                    </tr>
                </thead>

                <tbody>
                    
                    <tr v-for="(item, index) in sale_product_list" :key="index">
                        
                        <td class="border border-gray-300 px-2 py-1">{{ index + 1 }}</td>

                        <td class="border border-gray-300 px-2 py-1">
                            {{ item.stitching_label }}
                        </td>



                        <td class="border border-gray-300 px-2 py-1">

                        <!-- Shirt -->
                        <div v-if="item.stitch_type == 1">
                            <small>
                                Half: {{ item.halfshirt }} | Full: {{ item.fullshirt }}
                            </small>
                        </div>

                        <!-- Pant -->
                        <div v-else-if="item.stitch_type == 2">
                            <small>
                                Qty: {{ item.pant }}
                            </small>
                        </div>

                        <!-- Paint -->
                        <div v-else>
                            <small>
                                Qty: {{ item.pant || 1 }}
                            </small>
                        </div>

                    </td>





                  <td class="border border-gray-300 px-2 py-1">

                            <!-- Stitching (Shirt/Pant) -->
                            <div v-if="item.stichlabels  && item.stichlabels.length">
                                <!--<span v-for="(lbl, i) in item.label" :key="i">-->
                                <!--    {{ lbl }} : {{ item.lablevalue[i] }},-->
                                <!--</span>-->
                                <span v-for="(lbl, i) in item.stichlabels" :key="i">
                                     {{ lbl.lablevalue }},
                                </span>
                            </div>

                            <!-- Paint -->
                            <div v-else>
                                
                            </div>

                            <!-- Note -->
                            <div v-if="item.measurementnote" class="mt-1 text-xs text-blue-600">
                                {{ item.measurementnote }}
                            </div>

                        </td>
                        <td>
                             <div v-if="item.deliverydate" class="mt-1 text-xs text-blue-600">
                                {{ item.deliverydate }}
                            </div>

                        </td>

                     <td class="border border-gray-300 px-2 py-1 text-center">

                        <!-- Sirf Edit -->
                        <button @click="editMeasurement(item, index)" class="text-green-600">
                            <i class="ri-edit-line"></i>
                        </button>

                            <button @click="removeMeasurement(index)" class="text-red-600">
                            <i class="ri-delete-bin-line"></i>
                        </button>

                    </td>

                          

                    </tr>

                    <!-- Empty State -->
                    <tr v-if="sale_product_list.length === 0">
                        <td colspan="3" class="text-center text-red-500 border border-gray-300 py-2">
                            No Measurement Added
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>
    </div>
</div>





                 <div class="grid grid-cols-12 ">
                      <div class="col-span-2">
                            <label for="trialdate" class="form-label">Trial Date</label>
                            <input type="date" id="trialdate" v-model="trialdate" ref="trialdate"  
                                placeholder="Type Here" class="form-input" required autocomplete="off">
                        </div>
                        </div>



<button class="btn b-solid btn-primary-solid cursor-pointer shadow-sm shirt_btn" ref="save_btn" @click="complete_save_measurement">Save</button>
 <button v-if="cur_bill_saved" type="button"  @click="newEntry"
                    class="px-4 py-2 btn b-solid btn-danger-solid cursor-pointer shadow-sm mt-2 ml-2" >
                    New Entry
                </button>
<!-- table -->


            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->
   

    <!-- Start Delete Modal -->
    <div id="plusModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="relative m-4 p-4 w-2/5 min-w-[40%] max-w-[40%] rounded-lg bg-white shadow-sm">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5  measurement_bg_card">

                    <div class="mt-2">
                        <h5 class="mb-1 text-center text-danger">Add Measurement</h5>   
                    <div class="stich_qty">
                      <div v-if="current_selected_stitch_type==1">
                          <div>
                              <span>Half Shirt</span>
                              <input type="number"  class="form-input w-150" ref="halfshirt" v-model="stiching_.halfshirt"  @keydown.enter="focusNext('fullshirt')">
                          </div>
                          <div>
                              <span>Full Shirt</span>
                              <input type="number"  class="form-input w-150"  ref="fullshirt"  v-model="stiching_.fullshirt"  @keydown.enter="openSelectForStitchType()">
                          </div>
                          
                      </div>
                      <div v-else>
                          <input type="number"  class="form-input w-150"  ref="pant" v-model="stiching_.pant" @keydown.enter="openSelectForStitchType()">
                          
                      </div>
                    </div>
                        <div class="mt-2" v-if="already_selected_measurement_label">
                            Selected Measurement For :{{already_selected_measurement_label}}
                        </div>
                         <div class="mt-2" > 
                            <label for="stitchingmeasurement" class="form-label">Stitching Measurement</label> <br>
                            <select class="form-select " id="stitchingmeasurement" style="width:100%"
                                ref="stitchingmeasurement" v-model="sm.stitchingid">
                                <option value=""></option>
                                <option v-for="(item, index) in filteredMeasurements" :key="index" :value="item.id">{{
                                    item.name }}</option>
                            </select>
                        </div>
                        <div v-if="loading_stich_labels">{{loading_stich_labels}}</div>

                        <!-- <div v-for="(item, index) in stichlabels" :key="item.id">
                        <h1>{{ item.lable }}</h1>
                        <input type="text" v-model="lablevalue[index]" placeholder="Type Here"
                                class="form-input" required>
                      </div> -->
                    <div style="display: flex; flex-wrap: wrap; gap: 10px;" id="measurement_inputs">
                        
                        <div v-if="stichlabels && stichlabels.length>0">
                    <div v-if="stichlabels[0].stitch_type==1">
                             <div>
                                    <input
                                    type="text"
                                    v-model="stichlabels[0].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(0, stichlabels[0])"
                                    @keydown.enter="focusNextIp(0)"
                                    @focus="selectText($event)"
                                    :ref="'input0'"
                                    />
                                    
                                </div>
                                <!--3-->
                                 <div style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[1].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(1, stichlabels[1])"
                                    @keydown.enter="focusNextIp(1)"
                                    @focus="selectText($event)"
                                    :ref="'input1'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[2].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(2, stichlabels[2])"
                                    @keydown.enter="focusNextIp(2)"
                                    @focus="selectText($event)"
                                    :ref="'input2'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[3].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(3, stichlabels[3])"
                                    @keydown.enter="focusNextIp(3)"
                                    @focus="selectText($event)"
                                    :ref="'input3'"
                                    />
                                    
                                </div>
                                
                                <!--3-->
                                 <div  style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[4].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(4, stichlabels[4])"
                                    @keydown.enter="focusNextIp(4)"
                                     @focus="selectText($event)"
                                   :ref="'input4'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[5].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(5, stichlabels[5])"
                                    @keydown.enter="focusNextIp(5)"
                                    @focus="selectText($event)"
                                    :ref="'input5'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[6].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(6, stichlabels[6])"
                                    @keydown.enter="focusNextIp(6)"
                                    @focus="selectText($event)"
                                    :ref="'input6'"
                                    />
                                    
                                </div>
                                <!--1-->
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[7].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(7, stichlabels[7])"
                                    @keydown.enter="focusNextIp(7)"
                                    @focus="selectText($event)"
                                    :ref="'input7'"
                                    />
                                    
                                </div>
                                
                                <!--4-->
                                
                                 <div  style="display: flex;">
                                    <input
                                    type="text"
                                    v-model="stichlabels[8].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(8, stichlabels[8])"
                                    @keydown.enter="focusNextIp(8)"
                                    @focus="selectText($event)"
                                    :ref="'input8'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[9].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(9, stichlabels[9])"
                                    @keydown.enter="focusNextIp(9)"
                                    @focus="selectText($event)"
                                    :ref="'input9'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[10].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(10, stichlabels[10])"
                                    @keydown.enter="focusNextIp(10)"
                                    @focus="selectText($event)"
                                    :ref="'input10'"
                                    />
                                    <input
                                    type="text"
                                    v-model="stichlabels[11].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(11, stichlabels[11])"
                                    @keydown.enter="focusNextIp(11)"
                                    @focus="selectText($event)"
                                    :ref="'input11'"
                                    />
                                    
                                </div>
                                
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[12].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(12, stichlabels[12])"
                                    @keydown.enter="focusNextIp(12)"
                                    @focus="selectText($event)"
                                    :ref="'input12'"
                                    />
                                    
                                </div>
                                
                                 <div >
                                    <input
                                    type="text"
                                    v-model="stichlabels[13].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(13, stichlabels[13])"
                                    @keydown.enter="focusNextIp(13)"
                                    @focus="selectText($event)"
                                    :ref="'input13' "
                                    />
                                    
                                </div>

                     

                                
                        </div>


                    <div v-else> 

                                 <div>
                                    <input
                                    type="text"
                                    v-model="stichlabels[0].lablevalue"
                                    placeholder="Type Here"
                                    class="form-input"
                                    required
                                    style="width: 55px; margin-top: 5px;"
                                    @input="handleInputChange(0, stichlabels[0])"
                                    @keydown.enter="focusNextIp(0)"
                                    @focus="selectText($event)"
                                    :ref="'input0'"
                                    />
                                    
                                </div>
                                     <div>
                                        <input
                                        type="text"
                                        v-model="stichlabels[1].lablevalue"
                                        placeholder="Type Here"
                                        class="form-input"
                                        required
                                        style="width: 55px; margin-top: 5px;"
                                        @input="handleInputChange(1, stichlabels[1])"
                                        @keydown.enter="focusNextIp(1)"
                                        @focus="selectText($event)"
                                        :ref="'input1'"
                                        />
                                        
                                    </div>
                                     <div>
                                        <input
                                        type="text"
                                        v-model="stichlabels[2].lablevalue"
                                        placeholder="Type Here"
                                        class="form-input"
                                        required
                                        style="width: 55px; margin-top: 5px;"
                                        @input="handleInputChange(2, stichlabels[2])"
                                        @keydown.enter="focusNextIp(2)"
                                        @focus="selectText($event)"
                                        :ref="'input2'"
                                        />
                                        
                                    </div>
                                         <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[3].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(3, stichlabels[3])"
                                            @keydown.enter="focusNextIp(3)"
                                            @focus="selectText($event)"
                                            :ref="'input3'"
                                            />
                                            
                                        </div>
                                          
                               
                                
                                      <!--3-->
                                    <div  style="display: flex;">
                                            <input
                                            type="text"
                                            v-model="stichlabels[4].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(4, stichlabels[4])"
                                            @keydown.enter="focusNextIp(4)"
                                            @focus="selectText($event)"
                                        :ref="'input4'"
                                            />
                                            <input
                                            type="text"
                                            v-model="stichlabels[5].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(5, stichlabels[5])"
                                            @keydown.enter="focusNextIp(5)"
                                            @focus="selectText($event)"
                                            :ref="'input5'"
                                            /> 
                                        
                                    </div>

                                        <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[6].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(6, stichlabels[6])"
                                            @keydown.enter="focusNextIp(6)"
                                            @focus="selectText($event)"
                                            :ref="'input6'"
                                            />
                                            
                                        </div>

                                           <div>
                                            <input
                                            type="text"
                                            v-model="stichlabels[7].lablevalue"
                                            placeholder="Type Here"
                                            class="form-input"
                                            required
                                            style="width: 55px; margin-top: 5px;"
                                            @input="handleInputChange(7, stichlabels[7])"
                                            @keydown.enter="focusNextIp(7)"
                                            @focus="selectText($event)"
                                            :ref="'input7'"
                                            />
                                            
                                        </div>
                           


                    </div>

                               
                                
                                
                        </div>
                        
                            <!--<template-->
                            <!--    v-for="(item, index) in stichlabels"-->
                            <!--    :key="item.id"-->
                            <!--    class="form-group"-->
                            <!--    :style="getItemStyle(index)" >-->
                            <!--     <div>-->
                            <!--        <input-->
                            <!--        type="text"-->
                            <!--        v-model="item.lablevalue"-->
                            <!--        placeholder="Type Here"-->
                            <!--        class="form-input"-->
                            <!--        required-->
                            <!--        style="width: 55px; margin-top: 5px;"-->
                            <!--        @input="handleInputChange(index, item)"-->
                            <!--        @keydown.enter="focusNextIp(index)"-->
                            <!--         @focus="selectText($event)"-->
                            <!--       :ref="'input' + index"-->
                            <!--        />-->
                            <!--    </div>-->
                            <!--</template>-->
                    </div>


                          <div class="mt-2">
                                 <button type="button" @click="showstylemodal()" ref="style_btn"
                                 class="btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2">
                                 Style
                    </button>
                        </div>


                        <div class="mt-2">
                            <label for="" class="form-label">Note</label>
                            <input type="text" ref="delv_on_note" id="delv_on_note" v-model="selectedProduct.measurementnote"
                                placeholder="Type Here" class="form-input" required autocomplete="off">
                        </div>

                          <div class="mt-2">
                            <label for="" class="form-label">Delivery Date</label>
                            <input type="date" id="delv_on" v-model="selectedProduct.deliverydate" ref="deliverydate"  v-on:keyup.enter="saveSelections"
                                placeholder="Type Here" class="form-input" required autocomplete="off">
                        </div>




                        <div class="flex justify-end">
                             <button @click="reset_measurement" v-if="already_selected_measurement_label" id="saveBtn"
                                class="btn b-solid btn-danger-solid cursor-pointer shadow-sm mt-2">Reset</button>

                             
                            <button @click="save_measurement" id="saveBtn"  v-on:keyup.enter="save_measurement" ref="save_measurement_button"
                                class="btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2"  >Save</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>










    <!-- end plus Model -->

    <!-- Start Delete Modal -->




<!-- Start Style Modal -->
<div id="showstylemodal" tabindex="-1"  
    class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
    style="background: #00000052;z-index: 999999999;" @keydown.enter.prevent="handleEnterKey">
    <div class="relative m-4 p-4 w-2/5 min-w-[40%] max-w-[40%] rounded-lg bg-white shadow-sm">
        <div class="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
            <button type="button" @click="closeStyleModal"
                class="absolute top-3 end-2.5 text-gray-500 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full p-1.5">
                <i class="ri-close-line text-xl"></i>
            </button>
  
            <div v-if="current_selected_stitch_type==1">        
            <div class="p-5 max-h-[75vh] overflow-y-auto">
               <h5>Shirt Style</h5>
                <div class=" text-sm text-gray-800 dark:text-gray-200">

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sr</th>
                                <th>Style</th>
                                <th>Sub Style</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measurement_styel_Array" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.mainPoint }}</td>
                                <td>
                                    <ul style="" ref="style_open" tabindex="0" class="measurements_style_lable">
                                        <li v-for="(subPoint, subIndex) in item.subPoints" :key="subIndex" for="">
                                              <label class="cursor-pointer select-none">
                                            <input type="checkbox" :value="subPoint"  :checked="isChecked(item.mainPoint, subPoint)"
                                                                @change="toggleSelection(item.mainPoint, subPoint)" :data-main-point="item.mainPoint" :data-sub-point="subPoint" 
                                                        /> {{ subPoint }}</label>
                                        </li>
                                    </ul>
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-sm text-danger  dark:text-gray-300">
                                {{ selectedProduct.measurementnote }}
                            </div>
            </div>
            </div>

            <div v-else>
                    <div class="p-5 max-h-[75vh] overflow-y-auto">
                <h5>Pant Style</h5>
                <div class=" text-sm text-gray-800 dark:text-gray-200">

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sr</th>
                                <th>Style</th>
                                <th>Sub Style</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in measurement_styel_Array_pant" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.mainPoint }}</td>
                                <td>
                                    <ul style="" ref="style_open" tabindex="0"  class="measurements_style_lable">
                                        <li v-for="(subPoint, subIndex) in item.subPoints" :key="subIndex" for="">
                                              <label class="cursor-pointer select-none">
                                            <input type="checkbox" :value="subPoint"  :checked="isCheckedForPant(item.mainPoint, subPoint)"
                                                                @change="toggleSelectionPant(item.mainPoint, subPoint)" :data-main-point="item.mainPoint" :data-sub-point="subPoint" 
                                                        /> {{ subPoint }}</label>
                                        </li>
                                    </ul>
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-sm text-danger  dark:text-gray-300">
                                {{ selectedProduct.measurementnote }}
                            </div>
            </div>
            </div>

            <div class="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">

                           
<br>
                <button type="button" @click="saveSelections"   @keyup.enter="focusDeliveryDate"
                    class="px-4 py-2 btn b-solid btn-primary-solid cursor-pointer shadow-sm mt-2 ml-2" ref="save_style_btn">
                    Save Changes
                </button>
                
               
            </div>
        </div>
    </div>
</div>


































    <!-- End Delete Modal -->
</template>
<style scoped>
.shirt_btn,.pant_btn{
    margin-right: 50px;
    width: 150px;
}
.shirt_btn:active,.pant_btn:active{
    border: 2px solid red;
    box-shadow: 4px 4px 12px 4px #a8a1a1 !important;
}

.w-150{
    width: 150px;
}
.stich_qty div{
        display: flex;
    gap: 50px;
}
.modal_btn:focus{
    border:1px solid red;
}
 
.measurements_style_lable{
    display: ruby-text;
}
.measurements_style_lable label{
    margin-right: 10px;
    padding: 5px;
}
.measurements_style_lable label:hover{
    background: aquamarine;
}
    .form-input {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;

    }

    thead tr {
        background: #95d2ff3b;
    }

    .select2.select2-container .select2-selection {
        height: 25px;
    }

    .select2-selection__arrow {
        display: none;
    }

    .prd_name_col {
        width: 350px;
    }

    .prd_val_col {
        width: 80px;
    }

    .prd_val_col_x {
        width: 180px;
        text-align: center;
        background: #696900;
        color: white;
    }

    .prd_barcode_col {
        width: 150px;
    }

    .entry_row {
        background: yellow;
    }

    .select2-container {
        width: 100% !important;
    }

    td {
        /*color: black;*/
    }

    .right {
        text-align: right;
    }

    select {
        padding: 0px 0px !important;
        height: 30px !important;
    }

    .form-input:focus {
        background: yellow;
    }

    .dark .form-input:focus {
        background: white;
        color: black;
    }

    .dark .form-input {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;
        background: white;

    }

    .dark .select2 {
        height: 20px;
        padding: 15px 2px;
        border: 1px solid black;
        color: black;
        background: white;

    }

    

        /* element.style {
        background: #040300cc;
    } */

</style>

<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import axios from 'axios';

    export default {
        name: 'SaleView',
        components: {

        },
        mounted() {
                window.addEventListener('keydown', this.handleArrowKeys);
             
                if(this.$route.query.id){
                     this.getBasics(this.$route.query.id);

                }else{
                    this.getBasics();

                }
              

               this.showratetypemodal=true;
               
               
            //   setTimeout(() => { this.$refs.saleRateBtn.focus(); }, 200);

                // if (this.stitch_type_for == 1) {
                //     this.account.paid = this.account.total_payable;
                // }

        }, 
        
            beforeUnmount() {
              window.removeEventListener('keydown', this.handleArrowKeys);
            },
        
        data() {
            return {
                isMeasurementSaving:false,
            stiching_:{
              fullshirt:0,
              halfshirt:0,
              pant:0,
            },
                invoice:{
                    invoice_no:0,
                },
                

                get_sale_details:[],
                edit_sale_id:'',



                washing:{qty:0,rate:20,total:0},
                mainPointFor: '',
                subPointfor:'',

                temp_shirt:[],

                stitch_type_for:0,
                for_model_open:0,



                temp_pant:[],
                currentFocusedIndex: -1,
                selectedCheckboxes:[],
                selectedSubPoints: new Set(),
                selectedSubPointsPants: new Set(),
                isSet: 0,
                isAdd: 0,
                isEdit: 0,
                saleid: 0,
                isDelete: 0,
                deleteId: 0,
                productsList: [],
                customerList: [],
                filtermeasure: [],
                selectedProduct: [],
                sale_product_list: [],
                All_stiching_lables: [],
                showmodel: false,
                showratetypemodal:false,
                custid: '',

                Customer: { name: '', cell: '', address: '', dob: '' },
                prd: {},
                sale: { custcell: '', custgst: '', custaddress: '', custid: '', date: this.todayDate() ,selected_employeeid:0},
                account: { total: 0, qty: 0, gst: 0, paid: 0, total_payable: 0, discount: 0, remark: '' },
                prd_select_tag: null,
                employees: { empname: '', emprole: '0', isMainAdmin: 0 },
                all_employees:[],
                tag_prd_id: 0,
                cur_remove_row_index: 0,
                product_cat: [],
                qty_mtr: 0,
                qty_unit: 0,
                stitchid: null,

                calculatemsur: [],
                stiching_mesurements: [],
                filteredMeasurements: [],
                stichlabels: [],
                seletestetchid: '',

                sm: {
                    lablevalue: [],
                    stitchingid: '',
                    stitching_label: '',
                    lableid: [],
                    lable: [],

                },
                current_index_of_added_product: 0,
                selected_stitch_id: 0,
                loading_stich_labels: '',
                already_selected_measurement_label:'',
                trialdate:'',
                cur_bill_saved:false,
             
selections: {
      collar: [],
      silai: [],
      pocket: [],
      shoulder: [],
      front: [],
      cuff: []
    },
    current_selected_stitch_type:0,
    measurement_styel_Array: [
                        {
                            mainPoint: "शर्ट",
                            subPoints: [
                                "बु शर्ट",
                                "ॲपल कट जास्त",
                                "ॲपल कट",
                                "बु शर्ट / चॉक कट"
                            ],
                            status: "सक्रिय"
                        },
                        {
                            mainPoint: "कॉलर",
                            subPoints: [
                                "पॉईंटेड",
                                "कट वे",
                                "बटण डाउन",
                                "बॅण्ड  पट्टी",
                            ],
                            status: "प्रगतीत"
                        },
                        {
                            mainPoint: "शिलाई",
                            subPoints: [
                                "दाब",
                                "डबल",
                                "ट्रिपल",
                                "प्लेन",
                                "अर्घा दाब"
                            ],
                            status: "पूर्ण"
                        },
                        {
                            mainPoint: "पाकीट",
                            subPoints: [
                                "पेन",
                                "फ्लॅप",
                                "2",
                                "आतुन",
                                "नको"
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "फॅशन पट्टी",
                            subPoints: [
                                "फोल्ड",
                                "प्लेन",
                                "बटन डाऊन",
                                // "पेन पाकीट",
                                // "प्लेन फॅशन पट्टी"
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "शोल्डर",
                            subPoints: [
                                "V",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "कप",
                            subPoints: [
                                "2 इच",
                                "2 || इच",
                                "2 ||| इच",
                                "3 इच",
                                "साइड कव्हर",
                                "साइड शिलाई",
                               // "2 || इच "
                            ],
                            status: "प्रलंबित"
                        },
                        // {
                        //     mainPoint: "--",
                        //     subPoints: [
                        //         "साइड",
                        //         "कव्हर",
                        //         "साइड शिलाइ",
                        //     ],
                        //     status: "प्रलंबित"
                        // },
                         {
                            mainPoint: "टिप",
                            subPoints: [
                                "मेडियम फिटींग",
                                "फिटिंग",
                                "लुजिंग",
                            
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "अतिरिक्त स्टाईल",
                            subPoints: [
                                "नको",
                                "हवा आहे",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            "mainPoint": "शर्टचे प्रकार",
                            "subPoints": [
                                "अर्ध बाह्यांचा शर्ट",
                                "पूर्ण बाह्यांचा शर्ट"
                            ],
                            "status": "प्रलंबित"
                        }
                    ],



 measurement_styel_Array_pant: [
                        {
                            mainPoint: "प्लेट",
                            subPoints: [
                                "बिगर",
                                "2",
                                "1",
                                "3",
                            ],
                            status: "सक्रिय"
                        },
                        {
                            mainPoint: "पाकीट",
                            subPoints: [
                                "साइड",
                                "क्रॉस",
                                "फ्रंट",
                                "मोबाइल",
                                "पेन",
                            ],
                            status: "प्रगतीत"
                        },
                        {
                            mainPoint: "शिबँक पाकीटलाई",
                            subPoints: [
                                "1",
                                "2",
                                "फ्लॅप",
                                "2 पॅच",
                                "नको"
                            ],
                            status: "पूर्ण"
                        },
                        {
                            mainPoint: "वॉच पाकीट",
                            subPoints: [
                                "1",
                                "2",
                                "मोठा",
                                "नको"
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "साइड",
                            subPoints: [
                                "चिरवा",
                                "डबल टिप",
                                "किनारी टिप",
                                "दाब टिप",
                            ],
                            status: "प्रलंबित"
                        },
                        //  {
                        //     mainPoint: "शोल्डर",
                        //     subPoints: [
                        //         "1",
                        //     ],
                        //     status: "प्रलंबित"
                        // },
                         {
                            mainPoint: "लुप्स",
                            subPoints: [
                                "मोठा",
                                "रेग्युलर",
                                "फिक्स",
                                "3 मोटे",
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "इस्त्री",
                            subPoints: [
                                "उभी",
                                "आडवी",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "बॉटम",
                            subPoints: [
                                "फोल्ड",
                                "हात शिलाई",
                                "मशिन शिलाई",
                                "चैन",
                            ],
                            status: "प्रलंबित"
                        },
                         {
                            mainPoint: "टिप",
                            subPoints: [
                                "मेडियम फिट्टींग",
                                "फिट्टींग",
                                "लुजिग",
                            ],
                            status: "प्रलंबित"
                        },
                        {
                            mainPoint: "अतिरिक्त स्टाईल",
                            subPoints: [
                                "नको",
                                "हवा आहे",
                            ],
                            status: "प्रलंबित"
                        },

                         
                    ],













                    
                    isModalOpen:false,
                    isMesaurmentModalOpen:false,
                    isStyleModalOpen:false,
                    isEditMode:false,

            }
        },
        methods: {

        openSelectForStitchType(){
            $('#stitchingmeasurement').select2().select2('open')
            
        },
            openMeasurementModal(type) {
                        const modal = document.getElementById("plusModal");
                        

                        var self=this; 
                         if (!self.isEditMode) {
                                self.sm = {
                                    lablevalue: [],
                                    stitchingid: '',
                                    stitching_label: '',
                                    lableid: [],
                                    label: []
                                };
                                
                                if(self.stichlabels && self.stichlabels.length>0 && self.stichlabels[0]?.stitch_type!=type)
                                    self.stichlabels = [];
                                    
                                    
                                self.seletestetchid = '';
                                self.selected_stitch_id = 0;

                                self.stiching_ = {
                                    fullshirt: 0,
                                    halfshirt: 0,
                                    pant: 0
                                };

                                self.selectedProduct = {
                                    measurementnote: '',
                                    deliverydate: '' 
                                };
                                 self.selectedSubPoints= new Set();
                                 self.selectedSubPointsPants= new Set();
                            } 
                            
                            if (modal) {
                                    modal.classList.remove("hidden"); // 👈 show modal
                                }

                        self.current_selected_stitch_type=type;
                         self.filteredMeasurements = self.stiching_mesurements.filter(item =>item.parentid === String(type));
                         self.$nextTick(() => {
                               self.init_stitchingmeasurement();
                                if(type==1){
                                    self.$refs.halfshirt.focus();
                                     self.$refs.halfshirt.select();
                                }
                                else {
                                    self.$refs.pant.focus();
                                    self.$refs.pant.select();
                                }
                            //   $('#stitchingmeasurement').select2().select2('open');
                         });
                     

                        
                    },


                        handleArrowKey(event) {
                                const current = document.activeElement;
                                alert(event);

                         

                                // Arrow Right
                                if (event.key === "ArrowRight") {
                                    if (current === this.$refs.stichRateBtn) {
                                        this.$refs.saleRateBtn.focus();
                                    } else if (current === this.$refs.saleRateBtn) {
                                        this.$refs.stichRateBtn.focus();
                                    }
                                }

                                // Arrow Left
                                else if (event.key === "ArrowLeft") {
                                    if (current === this.$refs.saleRateBtn) {
                                        this.$refs.saleRateBtn.focus();
                                    } else if (current === this.$refs.saleRateBtn) {
                                        this.$refs.saleRateBtn.focus();
                                    }
                                }

                                else if (event.key === "Enter") {
                                    if (current === this.$refs.stichRateBtn) {
                                        this.setratetype(1);
                                    } else if (current === this.$refs.saleRateBtn) {
                                        this.setratetype(2);
                                    }
                                }
                            },





     focusQtyUnit() {
            const input = this.$refs.qty_unit;
            input.focus();
            input.select(); // This selects the full text inside the input
            },


           focuslastQtyUnit() {
   // alert("hello");
        const input =this.$refs.qty;
             input.focus();
            input.select();
    },
      focusDeliveryDate() {
    this.$refs.deliverydate.focus();
                 $("#showstylemodal").addClass('hidden');
   
  },
             selectText(event) {
                event.target.select();
              },
            getQtyMtr() {
                // this.prd.qty = (this.prd.qty_mtr || 0) * (this.prd.qty_unit || 0);
                
                    const qty = (this.prd.qty_mtr || 0);
                    const rate = (this.prd.qty_unit || 0);
                
                    const total = qty * rate;
                
                    this.prd.qty = total.toFixed(2);


                
                 this.getTotal(); 
            },
            setItemStichType() {
                var self = this;

                self.stitchid = this.prd.stich_type
                // alert(self.stitchid);
                if (this.prd.stich_type) {
                    this.prd.salerate = this.prd.stich_rate;
                    this.prd.total = this.prd.stich_rate;
                }


                // setTimeout(() => { self.$refs.qty.focus(); }, 200)
            },
           print_invoice(id) {
            // If stichlabels is empty or undefined, go for thermal print
            if ((this.ismeasurement == 0)) {
                window.open('/thermalPrint?q=' + this.saleid, '_blank');
            } else {
                if (this.saleid > 0 && this.setting[0].settingvalue == "Thermal") {
                window.open('/thermalPrint?q=' + this.saleid, '_blank');
                } else {
                window.open('/A4?q=' + this.saleid, '_blank');
                }
            }
            },
           
            new_bill() {
                if (this.saleid > 0)
                  window.location.reload();

            },
            todayDate() {
                const dateObj = new Date();
                var month = dateObj.getMonth() + 1;
                var day = dateObj.getDate();
                const currentDate = dateObj.getFullYear() + "-" + ((month < 10) ? '0' + month : month) + "-" + ((day < 10) ? '0' + day : day);
                return currentDate;
            },
            closeModal() {

                $("#editModal").addClass('hidden');
                $("#deleteModal").addClass('hidden');
                $("#tagModal").addClass('hidden');
                $("#plusModal").addClass('hidden');
                $("#showstylemodal").addClass('hidden');
                $("#showratetypemodal").addClass('hidden');
        

                this.isAdd = 0;
                this.isEdit = 0;
                this.isDelete = 0;
                this.deleteId = 0;
                this.isModalOpen=false;
                this.isStyleModalOpen=false;
                this.isMesaurmentModalOpen=false;
                this.showratetypemodal=false;
            },

   closeStyleModal() {

                $("#showstylemodal").addClass('hidden');
                // this.isMesaurmentModalOpen=true;
                this.isStyleModalOpen=false;
                this.isModalOpen=false;
                this.isMesaurmentModalOpen=false;

                this.isAdd = 0;
                this.isEdit = 0;
                this.isDelete = 0;
                this.deleteId = 0;
            },

 

            addModal() {

                this.Customer = { name: '', cell: '', address: '', gst: '' };

                if (!this.isAdd){
                    $("#editModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    this.isModalOpen=false;
                    $("#editModal").addClass('hidden');
                }

                $("#first_input").focus();
                this.isAdd = !this.isAdd;
            },
            focusNext(ref) {
                this.$refs[ref].focus();
               try { this.$refs[ref].select();} catch (e) { }
            },
            nextFocus(e) {
                try {
                    const inputs = Array.from(e.target.form.querySelectorAll('input'));
                    const index = inputs.indexOf(e.target);

                    if (index < inputs.length) {
                        try {
                            inputs[index + 1].focus();
                            inputs[index + 1].select();
                        } catch (error) {
                            $("#saveBtn").focus();
                        }
                    }
                } catch (e) { }
            },
            editModal(item) {
                if (item) {
                    let copy = JSON.parse(JSON.stringify(item));
                    this.cat = copy;
                }
                if (!this.isEdit){
                   // $('#cust_name').select2('close');
                    $("#editModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    $("#editModal").addClass('hidden');
                    this.isModalOpen=false;
                }
                
                this.isEdit = !this.isEdit;
            },

            deleteModal(id) {
                this.deleteId = id;
                if (!this.isDelete){
                    $("#deleteModal").removeClass('hidden');
                    this.isModalOpen=true;
                }
                else{
                    $("#deleteModal").addClass('hidden');
                    this.isModalOpen=false;
                }
                this.isDelete = !this.isDelete;
            },
            getTotal_added(item) {
                // alert(this.stitch_type_for);
                if(this.stitch_type_for==1){
                 
                     try {
                    //item.total = ((item.qty) ? parseFloat(item.qty) : parseFloat(item.set_qty)) * ((item.stich_rate) ? parseFloat(item.stich_rate) : parseFloat(item.set_rate));// parseFloat(item.salerate);
                    
                    //qty_mtr  17.07.2025
                    // item.total = ((item.qty_mtr) ? parseFloat(item.qty_mtr) : parseFloat(item.set_qty)) * ((item.stich_rate) ? parseFloat(item.stich_rate) : parseFloat(item.set_rate));
                        const qty = parseFloat(item.qty_mtr ?? item.set_qty) || 0;
                        const rate = parseFloat(item.stich_rate ?? item.set_rate) || 0;
                        const total = qty * rate;
                        item.total = total.toFixed(2);
                        // alert(item.total);
                        this.getFinalTotal();
                    } catch (error) {

                }

                }else{

                     try {
                    // item.total = ((item.qty) ? parseFloat(item.qty) : parseFloat(item.set_qty)) * ((item.salerate) ? parseFloat(item.salerate) : parseFloat(item.set_rate)) ;// parseFloat(item.salerate);
                    // item.total=(item.total).toFixed(2);
                    
                        const qty = parseFloat(item.qty ?? item.set_qty) || 0;
                        const rate = parseFloat(item.salerate ?? item.set_rate) || 0;
                        const total = qty * rate;
                        item.total = total.toFixed(2);
                        // alert(item.total);


                    this.getFinalTotal();
                } catch (error) {

                }

                }
               
            },
            getWashingTotal(){
                this.washing.total=parseFloat(this.washing.qty || 0)* parseFloat(this.washing.rate || 0);
                 this.getFinalTotal();
            },
            getFinalTotalAtPaid() {
                try {
                    



                } catch (error) {

                }
            },
           


            setratetype(_id) {
                if (_id == 1) {
                    this.stitch_type_for = 1;
                 //   alert(this.stitch_type_for);


                       this.showratetypemodal=false;
                       this.for_model_open = 1;

                    if(this.for_model_open ==1){
                          $("#cust_name").select2('open');
                    }
                      
               


                   // alert("stich rate applied");
                } else {
                        this.stitch_type_for = 0;
                        this.showratetypemodal=false;
                        this.for_model_open = 1;

                          if(this.for_model_open ==1){
                              $('#cust_name').val('23').trigger('change');
                            //   $("#cust_name").select2("val", "23");
                            //  $("#cust_name").select2('open');
                    }
                     
                }
            },








            getTotal() {
                // try {
                //     // this.prd.total = parseFloat(this.prd.qty) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                    
                //     //17.07.2025
                //     if(this.stitch_type_for==1)
                //         this.prd.total = parseFloat(this.prd.qty_mtr) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                //     else 
                //         this.prd.total = parseFloat(this.prd.qty) * parseFloat(this.stitch_type_for==1? this.prd.stich_rate:this.prd.salerate);
                //     this.getFinalTotal();
                // } catch (error) {

                // }
                
                //03112025
                try {
                        const isStitch = this.stitch_type_for === 1;
                    
                        const qty = parseFloat(isStitch ? this.prd.qty_mtr : this.prd.qty) || 0;
                        const rate = parseFloat(isStitch ? this.prd.stich_rate : this.prd.salerate) || 0;
                    
                        this.prd.total = (qty * rate).toFixed(2);
                    
                        this.getFinalTotal();
                    } catch (error) {
                        console.error('Error calculating product total:', error);
                    }
                
                
            },
            async getBasics() {
                var self = this;
                axios.post('get_measurement_details').then(function (response) {
                    
                    self.stiching_mesurements = response.data.stiching_mesurements;
                    self.customerList = response.data.customers;
                    self.All_stiching_lables = response.data.All_stiching_lables;
                    self.setting=response.data.setting;
                    self.invoice.invoice_no=response.data.inv_number;
                     

                }).then(() => {
                    

 
                    $("#cust_name").select2({
                        width: '80%',
                        dropdownAutoWidth: true,
                        placeholder: "Search Customer Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('change', function (event) {

                          var selected_customer = self.customerList.find(item => item.id === event.target.value);
                          
                           if(!selected_customer) return;
                          
                            self.sale.custid = selected_customer.id;
                            self.sale.custcell = selected_customer.cell;
                            self.sale.dob = selected_customer.dob;
                            self.sale.custaddress = selected_customer.address;
                            self.sale.balance = selected_customer.balance;
                            self.sale.date = self.todayDate();;
                            
                            self.$nextTick(() => {
                                self.$refs.shirt_btn.focus();
                            });
                            
                            self.getLastOrderOfSelectedSuctomer(self.sale.custid);
                    });
                        self.$nextTick(() => {
                            $('#cust_name').select2().select2('open');
                        
                        });
                });
            },
            init_stitchingmeasurement(){
                var self=this;
                    let isProcessing = false;
                    
                    $('#stitchingmeasurement').off('select2:select')
                    if ($('#stitchingmeasurement').hasClass("select2-hidden-accessible")) {
                        $('#stitchingmeasurement').select2('destroy');
                    }
                    

                $("#stitchingmeasurement").select2({
                        width: '100%',
                        placeholder: "Search Stitching Here...",
                        "language": {
                            "noResults": function () {
                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                            }
                        },
                        escapeMarkup: function (markup) {
                            return markup;
                        }
                    }).on('select2:select', function (event) {
                        
                         if (isProcessing) return;
                            isProcessing = true;
 
                        if (!self.isEditMode) {
                                self.sm = { lablevalue: [], stitchingid: '', stitching_label: '', lableid: [], label: [] };
                            }

                        self.sm.stitchingid = event.target.value;

                      
                        self.seletestetchid = event.target.value;

                        let selected_item = self.filteredMeasurements?self.filteredMeasurements.filter(item =>
                            item.id == self.seletestetchid
                        ):[];
                        //    let selected_item = self.seletestetchid;

  
                             console.log("selected_item",selected_item);
                        if (selected_item.length > 0) {

                            self.selected_stitch_id = selected_item[0].id;
                            self.sm.stitching_label = selected_item[0].name;

                            self.getlablevalue(self.seletestetchid);
                            
 
                        }



   setTimeout(() => {
        isProcessing = false;
    }, 100);
                        // //console.log(self.stichlabels);



                    });
            }, 
            save() {
                var self = this;
                var selected_cust = 0;
                if(self.Customer.name==''){
                    self.$swal("Customer Name is Required");
                }else if(self.Customer.cell==''){
                    self.$swal("Customer Contact is Required");
                }else if(self.Customer.dob==''){
                    self.$swal("Customer DOB is Required");
                }else if(self.Customer.address==''){
                    self.$swal("Customer Address is Required");
                }else
                {
                    axios.post('addCustomer', this.Customer)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            
                           
                                

                            if (isSuccess == 1) {
                                self.closeModal();
                                 self.customerList = response.data.list;

                                self.employees = response.data.userDetails;
    
                                selected_cust = response.data.custid;// for default select
    
                                self.employees = response.data.userDetails;
                                self.Customer = { name: '', cell: '', address: '', gst: '' };
                                
                                // window.location.reload();
                            } else
                                self.$swal(msg);
                                
                        }).then(() => {

                            $("#cust_name").select2({
                                width: '80%',
                                dropdownAutoWidth: true,
                                placeholder: "Search Customer Here...",
                                "language": {
                                    "noResults": function () {
                                        return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                    }
                                },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                            }).on('change', function (event) {
                                var selected_customer = self.customerList.find(item => item.id === event.target.value);
                                self.sale.custid = selected_customer.id;
                                self.sale.custcell = selected_customer.cell;
                                self.sale.custgst = selected_customer.gst;
                                self.sale.custaddress = selected_customer.address;
                                self.prd_select_tag.select2('open');
                            });

                            $('#cust_name').val(selected_cust);
                            $('#cust_name').trigger('change');
                        })
                        .catch(error => {
                            //console.log('Error on Authentication: ' + error);
                        });
                }
            },
            save_bill() {
                var self = this;
                if (self.sale.custid == '')
                    self.$swal("Please Select Customer...");
                else if (self.sale_product_list.length == 0)
                    self.$swal("Please Select Products...");
                else {
                    const loader = document.getElementById('global-loader');
                    if (loader) loader.style.display = 'flex';
    
                    axios.post('addSalesBill', { invoice_number :self.invoice,edit_sale_id:self.edit_sale_id,washing: self.washing,sale: self.sale, sale_items: JSON.stringify(self.sale_product_list), account: self.account, sm: self.sm,stitch_type:self.stitch_type_for })
                        .then(response => {
                            const loader = document.getElementById('global-loader');
                            if (loader) loader.style.display = 'none';
    
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.saleid = response.data.sales_id;
                            // self.productsList=response.data.list;
                            self.employees = response.data.userDetails;
                            self.Customer = { name: '', cell: '', address: '', gst: '' };
                            self.ismeasurement = response.data.ismeasurement;

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                                self.print_invoice();
                             
                                // window.location.reload();
                            }
                        })
                        .catch(error => {
                            //console.log('Error on Authentication: ' + error);
                        });
                }
            },

           
            remove_item() {

                this.sale_product_list.splice(this.deleteId, 1);
                // alert(this.deleteId);
                this.closeModal();

            },
       


//             save_measurement() {


         
//                 //console.log("Measurement For :-" +   this.selectedProduct.measurementnote);

//                // console.log("Stitch Type For:-"+this.current_selected_stitch_type);


//                             // if (this.current_selected_stitch_type == 1) {
//                             //         const note = this.selectedProduct.measurementnote;

                                   
//                             //         const mainPoint = note.mainPoint || '';
//                             //         const subPoints = Array.isArray(note.subPoints) ? note.subPoints : [];

                                   
//                             //         this.measurement_styel_Array.push({
//                             //             mainPoint: mainPoint,
//                             //             subPoints: subPoints
//                             //         });

                                  
//                             //         if (!this.selectedSubPoints) {
//                             //             this.selectedSubPoints = {};
//                             //         }

//                             //         this.selectedSubPoints[mainPoint] = [...subPoints];
//                             //     }

                           
//                                     // Now you can use mainPointFor and subPointFor
//                                  //  console.log("Main:", this.mainPointFor);
//                                 //  console.log("Sub:", this.subPointFor);



//             //   console.log("Assigned measurements:", this.sale_product_list[this.current_index_of_added_product]['measurements'] = { ...this.sm });

//                         // this.sale_product_list.push({ ...this.sm });

//                         this.sale_product_list.push({
//                                 ...this.sm,
//                                 halfshirt: this.stiching_.halfshirt,
//                                 fullshirt: this.stiching_.fullshirt,
//                                 stitch_type: this.current_selected_stitch_type
//                             });


//                         console.error(this.sale_product_list)  ;
// //                         for (let index = 0; index < this.sale_product_list.length; index++) {
// //                             const element = this.sale_product_list[index];
// //                             if(element?.measurements){
// //                                 continue;
// //                             }
// //                             if(this.sale_product_list[index].stich_type==this.current_selected_stitch_type){
// //                             this.sale_product_list[index]['measurements'] = { ...this.sm};
// //                             this.sale_product_list[index].measurementnote=this.selectedProduct.measurementnote;

// //                         //   console.log("Updated sale_product_list[", index, "]:", this.sale_product_list[index]);

                           
// // // sm.stitchingid

                     

// //                             }

// //                         }


                
                     
//                     //   //console.log(this.temp_pant);

//                 this.sm = { lablevalue: [], stitchingid: '', stitching_label: '', lableid: [], label: []};

//                 // this.selectedProduct={
//                 //     measurementnote:'',
//                 // }
                 
//                 // document.getElementById('plusModal').style.display = 'none';
//                 // this.showmodel=false;
//                 $("#plusModal").addClass('hidden');
//                 this.isMesaurmentModalOpen=true;
//                 this.isStyleModalOpen=false;
                
//                     this.isModalOpen=false;
//                 // this.$refs.measurement_save_btn.focus();


//             },





            save_measurement() {
                
                if(this.isMeasurementSaving)return;
                this.isMeasurementSaving=true;
                 
                const data = {
                    stichlabels:this.stichlabels,
                    halfshirt: this.stiching_.halfshirt,
                    fullshirt: this.stiching_.fullshirt,
                    pant: this.stiching_.pant,
                    stitch_type: this.current_selected_stitch_type,
                    measurementnote: this.selectedProduct.measurementnote,
                    deliverydate: this.selectedProduct.deliverydate,
                    stitching_label:this.sm.stitching_label
                };

                if (this.isEditMode && this.editIndex !== null) {

                    // ✅ UPDATE SAME ROW (IMPORTANT LINE)
                    this.$set 
                        ? this.$set(this.sale_product_list, this.editIndex, data)
                        : this.sale_product_list.splice(this.editIndex, 1, data);

                } else {

                    // ✅ NEW ADD
                    this.sale_product_list.push(data);
                }

                // reset
                this.isEditMode = false;
                this.editIndex = null;

                this.sm = {
                    lablevalue: [],
                    stitchingid: '',
                    stitching_label: '',
                    lableid: [],
                    label: []
                };
                  setTimeout(() => {  this.isMeasurementSaving=false;}, 300);
               setTimeout(() => {  this.$refs['shirt_btn'].focus();}, 300);
                $("#plusModal").addClass('hidden');
                
            },

















            filterseletestetchlable(seletestetchid) {
                var self = this;

                axios.post('getFilterMeasurement', { seletestetchid: self.seletestetchid }).then(function (response) {
                    self.filteredlable = response.data.filteredlable;
                });

            },


            // handleInputChange(index, item) {
            // alert("hello");
            //     //console.log(this.sm);
            //     //console.log(item);
            //     item.lablevalue.replace(".","|");//24.05.2025
            //     this.sm.lablevalue[index] = item.lablevalue;
            //     this.sm.lableid[index] = item.id;
            //     this.sm.label[index] = item.lable;

            //     // this.sale_product_list.push(this.current_index_of_added_product)
            //     // this.prd

            // },


            handleInputChange(index, item) {
               // alert("hello");
                //console.log(this.sm);
                //console.log(item);

                // Replace all "." with "|"
                item.lablevalue = item.lablevalue.replace(/\./g, "|");

                // Update your sm object
                this.sm.lablevalue[index] = item.lablevalue;
                this.sm.lableid[index] = item.id;
                this.sm.label[index] = item.lable;
            },









            getlablevalue(seletestetchid) {
                //  alert("called");
                // if(t)

                var self = this;
                if (self.sale.custid == 0) {

                    // self.$swal("Select Customer");
                    return;
                } else {
                    self.loading_stich_labels = "Loading labels";
                    axios.post('get_new_cust_measurement', { id: self.seletestetchid, custid: self.sale.custid }).then(function (response) {
                   
                       self.getallcustmeasurement =  response.data.getallcustmeasurement; 
                       var stitch_type=response.data?.stitch_type;
                       
                       console.log("self.stichlabels",self.stichlabels); 
                          if (self.getallcustmeasurement && self.getallcustmeasurement.length > 0) {
                              if(self.stichlabels && self.stichlabels.length>0 && self.stichlabels[0]?.stitch_type==stitch_type && response.data.dummy){
                                   console.log("continue existing stichlabels");
                              }
                              else{
                               
                                let rows = self.getallcustmeasurement;
                            
                                 if (rows && rows.length > 0)  
                                 {
                                
                                        for (let i = 0; i < rows.length; i++) {
                                
                                            if (self.stichlabels[i]) {
                                                self.stichlabels[i].lablevalue = rows[i].lablevalue || 0;
                                            } 
                                            else {
                                                self.stichlabels.push({
                                                    ...rows[i]
                                                });
                                            }
                                
                                        } 
                                 }
                            }
                            console.log("new stichlabels updateed");
                          }
                 
                
                console.log("self.stichlabels",self.stichlabels); 
 









                        
                    }).then(() => {
                       self.loading_stich_labels = "";
                            $('#measurement_inputs').find('input:visible:enabled:first').focus();
                    });


                }




            },

 normalizeArray(arr, size) {
    arr = arr || [];

    while (arr.length < size) {
        arr.push({ labelvalue: "" });   // Vue expects object, not 0
    }

    return arr;
},

 

            showstylemodal(){
 
                    var self=this;
                     $("#showstylemodal").removeClass('hidden');
                     this.isStyleModalOpen=true;
                    this.isModalOpen=true;
                    
                      const styleEl = self.$refs.style_open;
                          if (styleEl && styleEl.focus) {
                            styleEl.focus();
                          }
                        
                    self.$nextTick(() => {
                      const inputs = (Array.isArray(self.$refs.style_open) ? self.$refs.style_open[0] : self.$refs.style_open).querySelectorAll('input[type="checkbox"]');
                      if (inputs.length) inputs[0].focus();
                    });

            },


            getItemStyle(index) {
    if (index === 0) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index > 0 && index < 4) {
        return {
            display: 'contents' // Full width for first item
        }
    }
    else if (index > 3 && index < 7) {
        return {
            width: '-webkit-fill-available !important',
            display: 'contents', // Full width for first item
        }
    }
    else if (index === 7) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index === 12) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    else if (index === 13) {
        return {
            flex: '0 0 100%'  // Full width for first item
        }
    }
    return {
        display: 'contents' // Three items per row, accounting for gap
    };
},


    focusNextIp(currentIndex) {
      const nextInput = this.$refs['input' + (currentIndex + 1)];
      if (nextInput)   {
        nextInput.focus();
      }else{
          
         this.$refs['style_btn'].focus();// + (currentIndex + 1)];
          
      }
    },

saveSelections() {

  
  this.closeStyleModal();
   this.$refs['save_measurement_button'].focus();

},
 handleEnterKey() {
    const focused = document.activeElement;
    if (focused && focused.type === 'checkbox') {
      // Toggle the checkbox's checked state
      focused.checked = !focused.checked;

      
      const mainPoint = focused.dataset.mainPoint;
      const subPoint = focused.dataset.subPoint;
// //console.log(subPoint);
      if (mainPoint && subPoint) {
        this.toggleSelection(mainPoint, subPoint);
        
      }
    }
  },


    toggleSelection(mainPoint, subPoint) {

        this.mainPointFor = mainPoint;    
        this.subPointFor = subPoint;


          
          //console.log("toggleSelection");
          
          
        const key = `${mainPoint}:${subPoint}`;
        if (this.selectedSubPoints.has(key)) {
        this.selectedSubPoints.delete(key);
        } else {
        this.selectedSubPoints.add(key);
        }
        // //console.log(this.selectedProduct);
        // Update measurementnote with only subPoint names (not keys)
      this.selectedProduct.measurementnote = Array.from(this.selectedSubPoints).join(', ');

    },
    //29.05.205
      toggleSelectionPant(mainPoint, subPoint) {
          
          //console.log("toggleSelectionPant");
          
          
        const key = `${mainPoint}:${subPoint}`;
        if (this.selectedSubPointsPants.has(key)) {
            this.selectedSubPointsPants.delete(key);
            } else {
            this.selectedSubPointsPants.add(key);
            }
        
        // Update measurementnote with only subPoint names (not keys)
        this.selectedProduct.measurementnote = Array.from(this.selectedSubPointsPants)
        .map(item => item.split(':')[1]) // extract subPoint only
        .join(', ');

  




    },
    
    
    isChecked(mainPoint, subPoint) {
        return this.selectedSubPoints.has(`${mainPoint}:${subPoint}`);
    },
    
     isCheckedForPant(mainPoint, subPoint) {
        return this.selectedSubPointsPants.has(`${mainPoint}:${subPoint}`);
    },
    
    //26.05.2025
    
  handleArrowKeys(event) {
       
      if (event.key === "Escape") {
            if(this.isStyleModalOpen){
                this.isStyleModalOpen=false;
                
                $("#showstylemodal").addClass('hidden');
                 setTimeout(() => { $("#delv_on_note").focus();}, 300);
                // $("#showratetypemodal").addClass('hidden');
                return;
            }else   if(this.isStyleModalOpen){
              this.closeModal();
                return;
            }
          //   this.closeModal();
             // return;
            }
             if (event.key === "F2") {
              this.save_bill();
              return;
            }
            
         if (event.key === "F1") {
             event.preventDefault();
              $('#cust_name').select2('close');
              $("#editModal").removeClass('hidden');
                setTimeout(() => { $("#first_input").focus();}, 300);
              return;
            }
        
          
              
      
         if (document.querySelector('.select2-container--open')) {
            return;
          }else{
                //console.log('select2-container', "no ");
          }
          
          
      

  // focused checkbox not found in lists

    if (event.key === 'ArrowRight') {
        // if(this.stitch_type_for==0){
        //     this.$refs.saleRateBtn.focus();
        //     return;
        // }
            if(this.isModalOpen && this.isStyleModalOpen){
                
                
                 const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements

                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                
                    // Find which UL container the focused checkbox belongs to
                    let currentListIndex = -1;
                    let inputsInCurrentList = null;
                    let activeIndex = -1;
                    
                
                    for (let i = 0; i < styleOpenRefs.length; i++) {
                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                      const activeEl = document.activeElement;
                      const idx = Array.from(inputs).indexOf(activeEl);
                      if (idx !== -1) {
                        currentListIndex = i;
                        inputsInCurrentList = inputs;
                        activeIndex = idx;
                        break;
                      }
                    }
                    if (currentListIndex === -1 || !inputsInCurrentList) return; 
                     
                
                
                
                  if (activeIndex < inputsInCurrentList.length - 1) {
                    inputsInCurrentList[activeIndex + 1].focus();
                  } 
                  // else move to first checkbox of next list if exists
                  else if (currentListIndex < styleOpenRefs.length - 1) {
                    const nextListInputs = styleOpenRefs[currentListIndex + 1].querySelectorAll('input[type="checkbox"]');
                    if (nextListInputs.length) nextListInputs[0].focus();
                  }else{
                      this.$refs.save_style_btn.focus();
                  }
        }else{
             const activeElement = document.activeElement;

            if (activeElement === this.$refs.shirt_btn) {
                this.$refs.pant_btn.focus();
            }
        }
    } 
    else if (event.key === 'ArrowLeft') {
        // if(this.stitch_type_for==0){
        //     this.$refs.stichRateBtn.focus();
        //     return;
        // }
        
     if(this.isModalOpen && this.isStyleModalOpen){
         
          const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements

                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                
                    // Find which UL container the focused checkbox belongs to
                    let currentListIndex = -1;
                    let inputsInCurrentList = null;
                    let activeIndex = -1;
                
                    for (let i = 0; i < styleOpenRefs.length; i++) {
                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                      const activeEl = document.activeElement;
                      const idx = Array.from(inputs).indexOf(activeEl);
                      if (idx !== -1) {
                        currentListIndex = i;
                        inputsInCurrentList = inputs;
                        activeIndex = idx;
                        break;
                      }
                    }
                    
                    if (currentListIndex === -1 || !inputsInCurrentList) return; 
                    
                    
          if (activeIndex > 0) {
            inputsInCurrentList[activeIndex - 1].focus();
          } 
          // else move to last checkbox of previous list if exists
          else if (currentListIndex > 0) {
            const prevListInputs = styleOpenRefs[currentListIndex - 1].querySelectorAll('input[type="checkbox"]');
            if (prevListInputs.length) prevListInputs[prevListInputs.length - 1].focus();
          }else{
              this.$refs.save_style_btn.focus();
          }
         }else{
             const activeElement = document.activeElement;

            if (activeElement === this.$refs.pant_btn) {
                this.$refs.shirt_btn.focus();
            }
         }
    }
    else if (event.key === 'ArrowDown') {
       
        //   alert("hello");
      if(this.isModalOpen && this.isStyleModalOpen){
                        const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements
                
                                    if (!styleOpenRefs || !styleOpenRefs.length) return;
                                
                                    // Find which UL container the focused checkbox belongs to
                                    let currentListIndex = -1;
                                    let inputsInCurrentList = null;
                                    let activeIndex = -1;
                                
                                    for (let i = 0; i < styleOpenRefs.length; i++) {
                                      const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                                      const activeEl = document.activeElement;
                                      const idx = Array.from(inputs).indexOf(activeEl);
                                      if (idx !== -1) {
                                        currentListIndex = i;
                                        inputsInCurrentList = inputs;
                                        activeIndex = idx;
                                        break;
                                      }
                                    }
                                    
                                    if (currentListIndex === -1 || !inputsInCurrentList) {
                                         return; }
                                    
                                    
                            if (currentListIndex < styleOpenRefs.length - 1) {
                            const prevListInputs = styleOpenRefs[currentListIndex + 1].querySelectorAll('input[type="checkbox"]');
                            if (prevListInputs.length) prevListInputs[0].focus();
                          }
     }else{ 
             if(this.isModalOpen)
                return;
            const rows = this.$refs['selected_product'];
            if (!rows) return;
        
            const rowArray = Array.isArray(rows) ? rows : [rows];
          
              if(!this.isModalOpen) {
                if (this.currentFocusedIndex < rowArray.length - 1) {
                    this.currentFocusedIndex++;
                  }else{
                     console.warn('e.key :', "down");
                    //  console.log(this.$refs.discountInput);
                    // setTimeout(() => { this.$refs.discountInput.focus();this.$refs.discountInput.select(); }, 200)
                    //changed after washing on 13.11.2025 
                     setTimeout(() => { this.$refs.washing_qty.focus();this.$refs.washing_qty.select(); }, 200)
                              
                          
                  }
                  this.focusRow(rowArray, this.currentFocusedIndex);
              }
               
           
     }
    }
    else if (event.key === 'ArrowUp') {

      
      if(this.isModalOpen || this.isStyleModalOpen){
                  const styleOpenRefs = this.$refs.style_open; // this is an array of UL elements
        
                            if (!styleOpenRefs || !styleOpenRefs.length) return;
                        
                            // Find which UL container the focused checkbox belongs to
                            let currentListIndex = -1;
                            let inputsInCurrentList = null;
                            let activeIndex = -1;
                        
                            for (let i = 0; i < styleOpenRefs.length; i++) {
                              const inputs = styleOpenRefs[i].querySelectorAll('input[type="checkbox"]');
                              const activeEl = document.activeElement;
                              const idx = Array.from(inputs).indexOf(activeEl);
                              if (idx !== -1) {
                                currentListIndex = i;
                                inputsInCurrentList = inputs;
                                activeIndex = idx;
                                break;
                              }
                            }
                            
                            if (currentListIndex === -1 || !inputsInCurrentList) return; 
                            
                            
                 if (currentListIndex >0) {
                    const nextListInputs = styleOpenRefs[currentListIndex - 1].querySelectorAll('input[type="checkbox"]');
                    if (nextListInputs.length) nextListInputs[0].focus();
                  }else{
                      this.$refs.save_style_btn.focus();
                  }
      }else{
          if(this.isModalOpen)
                return;
            const rows = this.$refs['selected_product'];
            if (!rows) return;
        
            const rowArray = Array.isArray(rows) ? rows : [rows];
              
              if(!this.isModalOpen){ 
                  if (this.currentFocusedIndex > 0) {
                    this.currentFocusedIndex--;
                  }
                  this.focusRow(rowArray, this.currentFocusedIndex);
              }
         
      }  
      
       
                        
                        
   } 
   
  },
  
//    handleShortcut(e) {
//         console.warn('e.key :', e.key);
        
       
//        if (e.key === "Escape"){
//             // $("#plusModal").addClass('hidden');
//             //     $("#showstylemodal").addClass('hidden');
//              this.closeModal();
//              return;
//         }
       
//         if(this.isModalOpen)
//          return;
         
        
      
  
//     if ( (e.key=== 'ArrowDown' || e.key=== 'ArrowUp')) {
//         e.preventDefault(); // Optional: prevent browser's default
//        const rowRef = this.$refs['selected_product0'];
        
//           // It might be an array if used in v-for
//           const row = Array.isArray(rowRef) ? rowRef[0] : rowRef;
        
//           if (row && typeof row.focus === 'function') {
//             row.focus();
//           } else {
//             console.warn('Row is not focusable:', row);
//           }
//     }
//   }



handleShortcut(e) {
  
  

    

    // const rows = this.$refs['selected_product'];
    // if (!rows) return;

    // // Convert to array in case it's a single element
    // const rowArray = Array.isArray(rows) ? rows : [rows];

    // if (e.key === 'ArrowDown') {
    //   e.preventDefault();
    //   if(!this.isModalOpen) {
    //     if (this.currentFocusedIndex < rowArray.length - 1) {
    //         this.currentFocusedIndex++;
    //       }
    //       this.focusRow(rowArray, this.currentFocusedIndex);
    //   }
    // }

    // if (e.key === 'ArrowUp') {
    //   e.preventDefault();
    //   if(!this.isModalOpen){ 
    //       if (this.currentFocusedIndex > 0) {
    //         this.currentFocusedIndex--;
    //       }
    //       this.focusRow(rowArray, this.currentFocusedIndex);
    //   }
    // }
  },

  focusRow(rowArray, index) {
    const row = rowArray[index];
    if (row && typeof row.focus === 'function') {
      row.focus();
    } else {
      console.warn('Row is not focusable:', row);
    }
  },



editMeasurement(item, index) {

    this.isEditMode = true;
    this.editIndex = index;

    // ✅ type set (VERY IMPORTANT)
    this.current_selected_stitch_type = item.stitch_type;

    // ✅ modal open karo (same function use karo)
    this.openMeasurementModal(item.stitch_type);

    this.$nextTick(() => {

        // ✅ full data fill
        this.sm = JSON.parse(JSON.stringify(item));

        // ✅ qty fill
        this.stiching_ = {
            halfshirt: item.halfshirt || 0,
            fullshirt: item.fullshirt || 0,
            pant: item.pant || 0
        };

        // ✅ note fill
        this.selectedProduct = {
            measurementnote: item.measurementnote || '',
            deliverydate: item.deliverydate || ''
        };

        // ✅ SELECT2 FIX (IMPORTANT)
        if (item.stitchingid) {
            // $('#stitchingmeasurement')
            //     .val(item.stitchingid)
            //     .trigger('change');
        }

    });

},


removeMeasurement(index) {
    this.$swal({
        title: "Are you sure?",
        text: "This measurement will be deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        if (result.isConfirmed) {
            this.sale_product_list.splice(index, 1);
        }
    });
},


complete_save_measurement(){

                var self = this;


                if(self.invoice.invoice_no == ''){

                self.$swal("Enter Invoice Number!");

                }else{

                   axios.post('save_complete_measurement', { 
                    invoice_number: self.invoice.invoice_no,
                    sale: self.sale,
                    sale_items: JSON.stringify(self.sale_product_list),
                })
                        .then(response => {

                            
                          if (response.data.status == 1) {
                              self.cur_bill_saved=true;
                             
 
                                    const url = self.$router.resolve({
                                      path: '/new_measurement_print',
                                      query: {
                                        q: response.data.inv_id
                                      }
                                    })
                                    
                                    window.open(url.href, '_blank')

                                        // // ✅ Table data clear
                                        // self.sale_product_list = [];

                                        // // ✅ Measurement object reset
                                        // self.sm = {
                                        //     lablevalue: [],
                                        //     stitchingid: '',
                                        //     stitching_label: '',
                                        //     lableid: [],
                                        //     label: []
                                        // };

                                        // // ✅ Qty reset
                                        // self.stiching_ = {
                                        //     fullshirt: 0,
                                        //     halfshirt: 0,
                                        //     pant: 0
                                        // };

                                        // // ✅ Note + delivery reset
                                        // self.selectedProduct = {
                                        //     measurementnote: '',
                                        //     deliverydate: ''
                                        // };

                                        // // ✅ Selection reset
                                        // self.selectedSubPoints = new Set();
                                        // self.selectedSubPointsPants = new Set();

                                        // // ✅ Invoice reset (optional)
                                        // self.invoice.invoice_no = 0;

                                        // // ✅ Sale reset (optional)
                                        // self.sale = {
                                        //     custcell: '',
                                        //     custgst: '',
                                        //     custaddress: '',
                                        //     custid: '',
                                        //     date: self.todayDate(),
                                        //     selected_employeeid: 0
                                        // };

                                    }else
                                    self.$swal(response.data.msg);
                                        
                        
                        })
                        .catch(error => {
                            //console.log('Error on Authentication: ' + error);
                        });
               
            }



},
  newEntry(){
        this.$router.go(0);
  },
  
  getLastOrderOfSelectedSuctomer(custid){

            //     var self = this;


            //     if(self.invoice.custid == ''){
            //     //self.$swal("Enter Invoice Number!");
            //     return;

            //     }else{

            //       axios.post('getLastOrderOfSelectedSuctomer', { 
            //         custid:custid 
            //     })
            //             .then(response => {
            //                 if(response.data.latestInvNumber)
            //                     self.invoice.invoice_no=response.data.latestInvNumber;
                           
            //             })
            //             .catch(error => { 
            //             });
               
            // }



},
  
  
},
  
    }
</script>

